module.exports = __webpack_public_path__ + "static/media/plumbersstock.4c3fa46e.png";